import { css, cx } from 'emotion';

import {
	sideBarLayout,
	cardSection,
	headingMediumLight,
	mobileMaxWidthBreakpoint,
} from 'inside-out/global-styles';

export const subTitleStyle = cx(
	headingMediumLight,
	css({
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			fontSize: '16px',
			lineHeight: '18px',
		},
	})
);

export const featuredCardSectionStyle = css({
	margin: '60px 0',
	'& header': {
		marginBottom: '25px',
	},
});

export const sectionStyle = cardSection(60);

export const innerWrapperStyle = sideBarLayout.wrapper;

export const mobileFiltersStyle = sideBarLayout.mobileFilters;

export const mobileFiltersDropDownStyle = sideBarLayout.mobileFiltersDropDown;

export const leftStyle = sideBarLayout.leftSide(0);

export const rightStyle = sideBarLayout.rightSide(60);



// WEBPACK FOOTER //
// ./src/page-styles/news-and-events/index.js